module.exports = ".bg-modal {\n  background: rgba(0, 0, 0, 0.5); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/missing-capability/missing-capability.component.scss
// module id = ./src/app/missing-capability/missing-capability.component.scss
// module chunks = main